import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  cancelSubscription,
  changeSubscription,
  createCheckout,
  getPayments,
  getSubscription,
  getTestMode,
  getTierInfo,
  resumeSubscription,
  syncSubscription,
  updatePaymentMethod,
} from "@/lib/api/billing";

export function useTierInfo() {
  return useQuery({
    queryKey: ["billing", "tier"],
    queryFn: getTierInfo,
  });
}

export function useSubscription() {
  return useQuery({
    queryKey: ["billing", "subscription"],
    queryFn: getSubscription,
  });
}

export function usePayments() {
  return useQuery({
    queryKey: ["billing", "payments"],
    queryFn: getPayments,
  });
}

export function useTestMode() {
  return useQuery({
    queryKey: ["billing", "test-mode"],
    queryFn: getTestMode,
  });
}

export function useCreateCheckout() {
  return useMutation({ mutationFn: createCheckout });
}

export function useChangeSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: changeSubscription,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["billing"] }),
  });
}

export function useCancelSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: cancelSubscription,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["billing"] }),
  });
}

export function useResumeSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: resumeSubscription,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["billing"] }),
  });
}

export function useSyncSubscription() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: syncSubscription,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["billing"] }),
  });
}

export function useUpdatePaymentMethod() {
  return useMutation({ mutationFn: updatePaymentMethod });
}
